// 待选组件和属性

const GOODS_LIST_PROPS = {
  pagePadding: 15,
  goodsPadding: 8,
  imagePadding: 0,
  textStyle: 'left',
  newGoodsStyle: 1, // 1-n
  goodsStyle: 'noBorderWhiteBg', // noBorderWhiteBg cardShadow borderWhiteBg
  goodsRadius: 'square', //  round square
  fontWeight: 'normal', // normal bold
  showContent: ['goodsName', 'goodsPrice'],
  countDown: 'exhibition',
  goodsMark: '', //  newCN  hotCN  new  hot  custom
  customMarkFile: '',
  cartStyle: 1,
};
// 营销商品
const MARKETING_GOODS_LIST_PROPS = {
  pagePadding: 15, // 页面边距
  goodsPadding: 8, // 商品间距
  imagePadding: 0, // 图片间距
  newGoodsStyle: 1, // 商品样式
  heardStyleType: 1, // 秒杀样式类型
  textStyle: 'left',
  goodsStyle: 'noBorderWhiteBg', // noBorderWhiteBg cardShadow borderWhiteBg
  goodsRadius: 'square', //  round square
  fontWeight: 'normal', // normal bold
  showContent: ['goodsName', 'goodsPrice'],
  countDown: 'exhibition',
  customActivityLabel: '', //  自定义活动标识
  cartStyle: 1,
};
export default [
  {
    version: '2',
    data: [
      {
        fixed: true, // 固定, 不能被拖拽删除等操作
        type: 'headNav',
        label: '头部标题',
        controlGroup: 'header',
        attrs: {
          titleALign: 0,
          titleStyle: 0,
          titleContent: '',
          remarkName: '',
          imgs: {
            pictureUrl: '',
          },
        },
      },
      {
        type: 'banner',
        label: '轮播广告',
        controlGroup: 'main',
        attrs: {
          styleType: 3, //
          styleDotType: 1, //
          intervalSeconds: 5,
          upperSpacing: 0,
          downSpacing: 0,
          defaultHeight: false,

          imgs: [],
        },
      },
      {
        type: 'shopNav',
        label: '店铺导航',
        controlGroup: 'main',
        attrs: {
          styleType: 1,
          backgroundType: 1,
          imageFile: {
            pictureUrl: '',
          },
          topDistance: 10,
          bottomDistance: 10,
          borderWidth: 0,
          topRiehtRadius: 0,
          topLeftRadius: 0,
          bottomLeftRadius: 0,
          bottomRightRadius: 0,
          leftDistance: 0,
          rightDistance: 0,
          navs: [],
          backgroundColor: '#ffffff',
          borderColor: '#ffffff',
        },
      },
      {
        type: 'imgNav',
        label: '七巧板',
        controlGroup: 'main',
        attrs: {
          styleType: 1,
          navs: [],
          gutter: 0,
          topDistance: 0,
          bottomDistance: 0,
          pagePadding: 0,
          imgMargin: 0,
        },
      },
      {
        type: 'titleBar',
        label: '标题栏',
        controlGroup: 'main',
        attrs: {
          styleType: 1,
          name: '标题栏',
          fontSize: 18,
          fontWeight: 'bold', // normal bold
          nameColor: '#333',
          backgroundColor: '#f8f8f8',
          linkColor: '#999',
          arrowColor: '#999',
          lineColor: '#F46F55',
          linkItem: { ...CONST.DEF_LINK_ITEM },
        },
      },
      {
        type: 'searchBar',
        label: '搜索模块',
        controlGroup: 'main',
        attrs: {
          styleType: 1,
          placeholder: '',
          placeholderAlign: 'left', // 'center'
          isHotWordScroll: false,
          contentColor: '#888888',
          backgroundColor: '#f5f5f5',
          borderRadius: 'round', // round square
          transparency: 1,
          pagePadding: 30,
        },
      },
      {
        type: 'category',
        label: '分组模块',
        controlGroup: 'main',
        attrs: {
          styleType: 1,
          fontColor: '#333',
          backgroundColor: '#f8f8f8',
          activeColor: '#F46F55',
          showAll: true,
          menuPostion: 'normal', // top, normal
          listStyleType: 1, // [1,2,3]
          goodsListProps: _.cloneDeep(GOODS_LIST_PROPS),
          groups: [],
        },
      },
      {
        type: 'goods',
        label: '商品模块',
        controlGroup: 'main',
        attrs: {
          styleType: 2,
          goodsListProps: _.cloneDeep(GOODS_LIST_PROPS),
          goodsFrom: 'goods', // goods group
          goods: [], // id name imgList
          goodsGroup: {
            id: '',
            name: '',
            limitNum: 6,
            limitType: 'num',
            relativeItem: null,
          },
          userLinkUrl: null,
        },
      },
      {
        type: 'video',
        label: '视频组件',
        controlGroup: 'main',
        attrs: {
          videoSrcFrom: 'inner', // inner external
          externalVideoSrc: '',
          innerVideoFile: '',
          coverFile: '',
          autoPlay: false,
        },
      },
      {
        type: 'store',
        label: '门店模块',
        controlGroup: 'main',
        attrs: {
          list: [],
        },
      },
      {
        type: 'brand',
        label: '品牌组件',
        controlGroup: 'main',
        attrs: {
          fontColor: '#333',
          backgroundColor: '#f8f8f8',
          activeColor: '#F46F55',
          menuList: [], // 菜单列表
          menuType: 0, // 菜单形式 0:文字 1：图片
          rules: {},
        },
      },
      {
        type: 'divider',
        label: '辅助分隔',
        controlGroup: 'main',
        attrs: {
          leftRightEdges: 0, // 页面左右边距
          height: 30, // 页面高度
          bgColor: 'transparent', // 页面背景色
          rules: {}
        },
      },
      {
        type: 'coupon',
        label: '优惠券',
        controlGroup: 'market',
        attrs: {
          list: [],
        },
      },
      {
        type: 'freeShipping',
        label: '满减邮',
        controlGroup: 'market',
        attrs: {
          freeShippingList: [],
          componentBottomCss: 0,
          componentTopCss: 0,
          borderCss: 1,
          goodsCss: 1,
          shopCarCss: '1',
          goodsFrom: 'goods',
          goods: [],
          activeList: [
            // {
            //   name:'默认名称',
            //   goodsCount:2,
            //   goodsList:[],
            //   activeId:null
            // }
          ],
          actvieContent: {
            countdown: false,
            underlinedPrice: false,
            commoditySales: false,
            shopCar: false,
          },
        },
      },
      {
        type: 'fullReduction',
        label: '满减送',
        controlGroup: 'market',
        attrs: {
          goodsListProps: _.cloneDeep(MARKETING_GOODS_LIST_PROPS),
          mainImgs: [], // 主图
          showGoodsCount: 6, // 展示商品个数
          activeList: [], // 已选活动
          styleType: 3, // 排列方式
          goodsFrom: 'fullReduction',
          // 商品范围: 0,1,2
          goodsFlag: -1,
          goods: [],
          countDown: 2,
          heardStyleType: 1, // 样式选择项 依次为 1 2 3
          textStyle: 1
        },
      },
      {
        type: 'secKill',
        label: '限时秒杀',
        controlGroup: 'market',
        attrs: {
          goodsListProps: _.cloneDeep(MARKETING_GOODS_LIST_PROPS),
          mainImgs: [], // 主图
          showGoodsCount: 6, // 展示商品个数
          activeList: [], // 已选活动
          styleType: 3, // 排列方式
          goodsFrom: 'secKill',
          goods: [],
          countDown: 2,
          heardStyleType: 1, // 样式选择项 依次为 1 2 3
          textStyle: 1,
        },
      },
      //添加拼团
      {
        type: 'groupBuying',
        label: '拼团',
        controlGroup: 'market',
        attrs: {
          setting: {
            groupActivities: [],
            styleType: false, // 样式切换
            styleChoose: '1', // 开始默认勾选
          },
        },
        StyleSwitch: {
          SwitchBoolean: false,
        },
      },
      {
        type: 'countDown',
        label: '倒计时',
        controlGroup: 'main',
        attrs: {
          time: [],
          title: '',
          backgroundColorType: 0,
          imgUrl: '',
          backgroundColor: '#FB8064',
          fontColor: '#FFFFFF',
          activeColor: '#FB8064',
          placeholderAlign: 'flex-start',
          pagePadding: 0,
        },
      },
    ],
  },
];
